import { usePitcherApi, PitcherBroadcastedEventName } from '@sdk/main'
import { PeerConnectivityActions, sendPeerConnectivityEvent } from '@sdk/peer-connectivity'

async function shouldBroadcastEvent(): Promise<boolean> {
  try {
    const api = usePitcherApi()
    const env = await api.getEnv()

    if (env.mode !== 'IOS') {
      // NOTE: Broadcast route events only in case iOS (as using native MultipeerConnectivity iOS framework)
      return false
    }
    return true
  } catch (error) {
    console.error('Failed to check broadcast conditions:', error)
    return false
  }
}

export async function broadcastRouteChangedEvent(routeName: string, routePath: string) {
  if (!(await shouldBroadcastEvent())) {
    return
  }

  try {
    const api = usePitcherApi()

    if (!routeName || !routePath) {
      console.warn('Cannot broadcast route changed event: missing route name or path')
      return
    }

    await sendPeerConnectivityEvent({
      action: PeerConnectivityActions.ROUTE_CHANGE,
      data: {
        routeName,
        routePath,
      },
    })
    await api.broadcast({
      type: PitcherBroadcastedEventName.ROUTE_CHANGED,
      body: {
        route_name: routeName,
        route_path: routePath,
      },
    })
  } catch (error) {
    console.error('Failed to broadcast route changed event:', error)
  }
}

export default function useBroadcastRouteChange() {
  return {
    broadcastRouteChangedEvent,
  }
}
